import { useState } from 'react';
import { useCreateStavba } from '../../api/hooks';
import type { StavbaCreate } from '../../api/schemas';
import styles from '../ares/CompanyPickerButton.module.css';

/**
 * Tlačítko „💾 Uložit stavbu" — založí stavbu v DB (/api/stavby/ POST).
 * Analogie k SaveCompanyButton.
 */

export interface SaveStavbaButtonProps {
  build: () => StavbaCreate | null;
  label?: string;
  compact?: boolean;
  title?: string;
}

export function SaveStavbaButton({
  build,
  label = 'Uložit stavbu',
  compact,
  title,
}: SaveStavbaButtonProps) {
  const create = useCreateStavba();
  const [status, setStatus] = useState<null | { kind: 'ok' | 'err'; msg: string }>(null);

  async function handleClick() {
    const payload = build();
    if (!payload || !payload.nazev.trim()) {
      setStatus({ kind: 'err', msg: 'Vyplňte alespoň název stavby.' });
      window.setTimeout(() => setStatus(null), 3000);
      return;
    }
    try {
      await create.mutateAsync(payload);
      setStatus({ kind: 'ok', msg: `✓ „${payload.nazev}" uloženo` });
      window.setTimeout(() => setStatus(null), 3000);
    } catch (e) {
      setStatus({
        kind: 'err',
        msg: e instanceof Error ? e.message : 'Chyba při ukládání',
      });
      window.setTimeout(() => setStatus(null), 4000);
    }
  }

  const hint = status
    ? status.kind === 'ok'
      ? status.msg
      : `✗ ${status.msg}`
    : title ?? 'Uložit stavbu';

  return (
    <button
      type="button"
      className={styles.trigger}
      onClick={handleClick}
      disabled={create.isPending}
      title={hint}
      style={
        status
          ? {
              borderColor:
                status.kind === 'ok' ? 'rgba(52,211,153,0.4)' : 'rgba(239,68,68,0.4)',
              color: status.kind === 'ok' ? 'var(--sd-success)' : 'var(--sd-danger)',
            }
          : undefined
      }
    >
      <span aria-hidden>💾</span>
      {!compact && <span>{create.isPending ? 'Ukládám…' : label}</span>}
    </button>
  );
}
